export default __webpack_public_path__ + "static/media/icon-analytics-dark.13cdad83.svg";